<h2 mat-dialog-title>{{ data.objective.title }}</h2>
<div mat-dialog-content>
  <app-company-product-objective [objective]="data.objective" [show_company_product_context]="false" />
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close()">Cerrar</button>
</div>
